// extracted by mini-css-extract-plugin
module.exports = {"root":"Home_root__2bI81"};